var _path, _path2, _path3, _path4, _path5, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGradableIc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.3751 1.98437L3.73459 1.98437C3.4269 1.98437 3.13182 2.1066 2.91426 2.32417C2.69669 2.54173 2.57446 2.83682 2.57446 3.1445L2.57446 12.4255C2.57446 12.7332 2.69669 13.0283 2.91426 13.2458C3.13182 13.4634 3.4269 13.5856 3.73459 13.5856L10.6953 13.5856C11.003 13.5856 11.2981 13.4634 11.5157 13.2458C11.7332 13.0283 11.8555 12.7332 11.8555 12.4255L11.8555 5.46475L8.3751 1.98437Z",
    stroke: "#3A3A3A",
    strokeWidth: 0.79014,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.43066 5.69678L6.77992 5.69678",
    stroke: "#3A3A3A",
    strokeWidth: 0.696076,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.43066 7.08911L5.82282 7.08911L7.21497 7.08911",
    stroke: "#3A3A3A",
    strokeWidth: 0.696076,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.43066 8.4812L5.82282 8.4812L6.51889 8.4812",
    stroke: "#3A3A3A",
    strokeWidth: 0.696076,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.375 1.98438L8.375 5.46475L11.8554 5.46475",
    stroke: "#3A3A3A",
    strokeWidth: 0.696079,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1169_1018)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.30313 10.5694C10.2001 10.5694 10.9273 9.84223 10.9273 8.94522C10.9273 8.04821 10.2001 7.32104 9.30313 7.32104C8.40612 7.32104 7.67896 8.04821 7.67896 8.94522C7.67896 9.84223 8.40612 10.5694 9.30313 10.5694Z",
    stroke: "#3A3A3A",
    strokeWidth: 0.696076,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.42382 10.3119L8.14307 12.4256L9.30319 11.7296L10.4633 12.4256L10.1826 10.3096",
    stroke: "#3A3A3A",
    strokeWidth: 0.696076,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1169_1018"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.17646,
    height: 6.96076,
    fill: "white",
    transform: "translate(7.21484 6.39282)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradableIc);
export default __webpack_public_path__ + "static/media/gradable_ic.0aa8613be6acc65b5eef80903435ca82.svg";
export { ForwardRef as ReactComponent };